import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { colors } from "~/utils/colors";
import { callWithSupport } from "~/utils/business";

const { brand, white } = colors;

const useStyles = makeStyles(() => ({
	text: {
		textAlign: "center",
	},
	actions: {
		justifyContent: "center",
		flexDirection: "column",
		padding: "0 16px 16px 16px",
		gap: 8,
	},
	whatsappButton: {
		backgroundColor: "#722F37",
		color: white,
		height: 44,
		fontSize: "15px",
		width: "100%",
		borderRadius: "25.5px",
		textTransform: "none",
		"&:hover": {
			backgroundColor: "#5a2329",
		},
		"&:active": {
			backgroundColor: "#5a2329",
		},
	},
}));

const SupportErrorDialog = ({
	open,
	onClose,
	title,
	message,
	supportMessage,
}) => {
	const classes = useStyles();
	const { t } = useTranslation();

	const handleSupport = () => {
		callWithSupport(supportMessage, t);
		onClose();
	};

	return (
		<Dialog
			onClose={onClose}
			open={open}
			PaperProps={{
				style: { borderRadius: 30, maxWidth: 312, width: "100%" },
			}}>
			<DialogTitle className={classes.text}>{title || t("paymentDeclined")}</DialogTitle>
			<DialogContent>
				<DialogContentText className={classes.text}>
					{message || t("paymentProcessingError")}
				</DialogContentText>
			</DialogContent>
			<DialogActions className={classes.actions}>
				<Button className={classes.whatsappButton} onClick={handleSupport}>
					{t("btnSupport")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default SupportErrorDialog;
